module.exports = __webpack_public_path__ + "static/media/snappy-with-shadow.35e5ef1c.svg";